define('dependencies/libs/ninepatch/ninepatch',['pixi'], function (PIXI) {
	PIXI.NinePatch = function (width, height, layers, scaleMode) {

		PIXI.DisplayObjectContainer.call(this);

		this.scaleMode = scaleMode || PIXI.NinePatch.scaleModes.NINEPATCH;

		this.targetWidth = width;
		this.targetHeight = height;

		this.loaded = 0;

		this.updateCallback = null;
		this.readyCallback = null;

		var method = 'fromFrame';

		this.onTextureUpdateBind = this.onTextureUpdate.bind(this);

		for (var i = 0; i < 9; i++) {
			this.addChild(layers[i]);
			if (!this.children[i].texture.baseTexture.hasLoaded) {
				this.children[i].texture.on('update', this.onTextureUpdateBind);
			} else {
				this.loaded++;
			}
		}

		this.children[2].anchor.set(1, 0);
		this.children[5].anchor.set(1, 0);
		this.children[6].anchor.set(0, 1);
		this.children[7].anchor.set(0, 1);
		this.children[8].anchor.set(1, 1);

		this.head = this.children[1];
		this.body = this.children[4];

		if (this.loaded < 9) {
			this.alpha = 0;
		} else {
			this.update();
		}
	};

	PIXI.NinePatch.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
	PIXI.NinePatch.prototype.constructor = PIXI.NinePatch;

	PIXI.NinePatch.scaleModes = {
		DEFAULT: 1,
		NINEPATCH: 2
	};

	Object.defineProperty(PIXI.NinePatch.prototype, 'width', {
		get: function () {
			if (this.scaleMode === PIXI.NinePatch.scaleModes.DEFAULT) {
				return this.scale.x * this.getLocalBounds().width;
			} else {
				return this.scale.x * this.targetWidth;
			}
		},
		set: function (value) {

			if (this.scaleMode === PIXI.NinePatch.scaleModes.DEFAULT) {
				var width = this.getLocalBounds().width;

				if (width !== 0) {
					this.scale.x = value / (width / this.scale.x);
				} else {
					this.scale.x = 1;
				}


				this._width = value;
			} else {
				this.update(value, this.targetHeight);
			}
		}
	});

	Object.defineProperty(PIXI.NinePatch.prototype, 'height', {
		get: function () {

			if (this.scaleMode === PIXI.NinePatch.scaleModes.DEFAULT) {
				return this.scale.y * this.getLocalBounds().height;
			} else {
				return this.scale.y * this.targetHeight;
			}
		},
		set: function (value) {

			if (this.scaleMode === PIXI.NinePatch.scaleModes.DEFAULT) {
				var height = this.getLocalBounds().height;

				if (height !== 0) {
					this.scale.y = value / (height / this.scale.y);
				} else {
					this.scale.y = 1;
				}

				this._height = value;
			} else {
				this.update(this.targetWidth, value);
			}
		}
	});

	PIXI.NinePatch.prototype.onUpdate = function (callback) {
		this.updateCallback = callback;

		return this;
	};

	PIXI.NinePatch.prototype.onReady = function (callback) {
		if (this.loaded === 9) {
			callback();
		} else {
			this.readyCallback = callback;
		}

		return this;
	};


	PIXI.NinePatch.prototype.update = function (width, height) {

		if (width !== undefined) {
			this.targetWidth = width;
		}

		if (height !== undefined) {
			this.targetHeight = height;
		}

		if (this.loaded !== 9) return;

		var child;

		child = this.children[1];
		child.position.set(this.children[0].width, 0);
		child.width = this.targetWidth - child.x - this.children[2].width;

		child = this.children[2];
		child.position.set(this.targetWidth, 0);

		child = this.children[3];
		child.position.set(0, this.children[0].height);
		child.height = this.targetHeight - child.y - this.children[6].height;

		child = this.children[4];
		child.position.set(this.children[1].x, this.children[3].y);
		child.height = this.children[3].height;
		child.width = this.children[1].width;

		child = this.children[5];
		child.position.set(this.targetWidth, this.children[3].y);
		child.height = this.children[3].height;

		child = this.children[6];
		child.position.set(0, this.targetHeight);

		child = this.children[7];
		child.position.set(this.children[1].x, this.targetHeight);
		child.width = this.children[1].width;

		child = this.children[8];
		child.position.set(this.targetWidth, this.targetHeight);

		if (this.updateCallback) {
			this.updateCallback();
		}
	};

	PIXI.NinePatch.prototype.onTextureUpdate = function () {
		if (++this.loaded === 9) {
			this.alpha = 1;
			this.update();

			if (this.readyCallback) {
				this.readyCallback();
				this.readyCallback = null;
			}
		}
	};

	return PIXI.NinePatch;

});

